import { useContext, useEffect, useState } from "react";
import { Modal } from "../../components";
import { useModal } from "../../hooks";
import { StatusChip } from "../../utils/chipUtils";
import { loaderContext, notificationContext } from "../../context/context";
import { apiService, campaignService, regexService, userService } from "../../service";
import numberFormat from "../../utils/numberFormat";
import dateFormat, { getTimeStamp } from "../../utils/dateFormat";
import dayjs from "dayjs";
import {
  DatePicker,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useOutletContext } from "react-router-dom";

let pagecount = 1;

const initialFilterState = {
  searchvalue: "",
  fromdate: dayjs().subtract(7, "days"),
  todate: dayjs(),
};

const templateState = {
  pop_desc: "",
  sms_templateid: "",
  email_templateid: "",
  whatsapp_templateid: "",
  sms_content: "",
  email_content: "",
  whatsapp_content: "",
};

function BulkUpload() {
  const toast = useContext(notificationContext);
  const loader = useContext(loaderContext);

  const uploadModal = useModal();
  const dataModal = useModal();
  const filterModal = useModal();

  const [isPagination, setPagination] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [fileName, setFileName] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isFilter, setFilterStatus] = useState(false);
  const [filterValue, setFilterValue] = useState(initialFilterState);
  const [paymentPurpose, setPaymentPurpose] = useState();
  const [templateDetails, setTemplateDetails] = useState(templateState);

  const [rowData, setRowData] = useState();
  const [isFile, setFile] = useState(false);

  const [fileList, setFileList] = useState([]);

  const submitFile = async () => {
    loader.showLoader();
    const file = document.getElementById("file");
    const response = await campaignService.uploadFile(file, fileName);

    if (response.data) {
      toast.success("File Uploaded Successfully");
      getFileList();
      uploadModal.hideModal();
      loader.hideLoader();
    } else {
      if (response.error.code != 101) {
        toast.error(response?.error?.message);
      }
    }

    loader.hideLoader();
  };

  const handleFileValidation = () => {
    setFile(false);
    let fileDetails = document.getElementById("file").files;
    const validFileType = [
      ".csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    try {
      if (fileDetails[0].size > 5000000000) {
        fileDetails = null;
        throw 500;
      } else if (!validFileType.includes(fileDetails[0].type)) {
        fileDetails = null;
        throw 600;
      } else {
        document.getElementById("file-name").innerHTML = fileDetails[0].name;
        setFile(true);
      }
    } catch (error) {
      if (error === 500) {
        toast.error("File Size Exceeds.");
      } else if (error === 600) {
        toast.error("Invalide File type. Upload only Excel files.");
      }
    }
  };

  const getFileList = async () => {
    if (pageCount == 1) {
      setTotalCount(0);
      setFileList([]);
    }
    const filterData = {
      searchtext: filterValue?.searchvalue || "",
      fromdate: dayjs(filterValue?.fromdate).format("YYYY-MM-DD"),
      todate: dayjs(filterValue?.todate).format("YYYY-MM-DD"),
      pagecount: pagecount,
    };
    try {
      const response = await campaignService.getFileList(filterData);

      if (response.error) {
        if (response.error.code != 101) {
          toast.error(response.error.message);
        }
      } else {
        if (pageCount > 1) {
          setFileList(fileList?.concat(response.data));
        } else {
          setFileList(response.data || []);
          setTotalCount(response?.Totalrecord || 0);
        }
      }
    } catch (error) {
      if (isPagination) {
        setPageCount(pageCount - 1);
      }
    } finally {
      setPagination(false);
      setIsLoading(false);
      loader.hideLoader();
    }
  };

  const handleFileDownload = async (data) => {
    loader.showLoader();
    const response = await campaignService.bulkFileDownload(data);
    loader.hideLoader();
    if (response.error) {
      toast.error("File Download failed. Please try again after sometimes.");
    } else if (response.data) {
      toast.success(
        `Your file ${response.data.fileName} has been downloaded successfully.`
      );
    }
  };

  const hadleRowSelect = (data) => {
    setRowData(data);
    dataModal.showModal();
  };

  const downloadSampleFormat = () => {
    loader.showLoader();
    const fileName = "Sample_file_" + getTimeStamp();
    const response = campaignService.downloadExcelFile(
      userService.userData.sampleExcel,
      fileName
    );
    if (!response) {
      toast.error(
        "Sample File Download failed. Please try again after sometimes."
      );
    } else if (response) {
      toast.success(`Sample File has been downloaded successfully.`);
    }
    loader.hideLoader();
  };

  const handleDateChange = (value, filterid) => {
    if (filterid === "fromdate" && dayjs(value).isAfter(filterValue?.todate)) {
      setFilterValue({ ...filterValue, todate: value, [`${filterid}`]: value });
    } else {
      setFilterValue({ ...filterValue, [`${filterid}`]: value });
    }
  };

  // useEffect(() => {
  //   if (filterValue?.fromdate && filterValue?.todate) {
  //     loader.showLoader();
  //     setPageCount(1);
  //     getFileList();
  //   }
  // }, [filterValue?.fromdate || filterValue?.todate]);

  const incrementPageCount = () => {
    if (totalCount > pageCount * 10 && !isPagination) {
      setPageCount(pageCount + 1);
      setPagination(true);
    }
  };

  const handleSearch = () => {
    if (pageCount == 1) {
      setIsLoading(true);
      getFileList();
    } else {
      setPageCount(1);
    }
  };

  const handleFilter = (actionType) => {
    if (actionType === "APPLY") {
      handleAPICall();
    } else if (actionType === "RESET") {
      setFilterValue({
        searchvalue: filterValue?.searchvalue || "",
        fromdate: dayjs().subtract(7, "days"),
        todate: dayjs(),
      });
      setPageCount(1);
      setIsLoading(true);
      setFilterStatus(true);
    }
    filterModal.hideModal();
  };

  const handleAPICall = () => {
    if (pageCount == 1) {
      setIsLoading(true);
      getFileList();
    } else {
      setPageCount(1);
    }
  };

  useEffect(() => {
    if (filterValue?.searchvalue == "" && !isLoading) {
      handleSearch();
    }
  }, [filterValue?.searchvalue]);

  useEffect(() => {
    pagecount = pageCount;
    if (pageCount > 1 && isPagination) {
      getFileList();
    }
    if (pageCount == 1 && !isLoading) {
      setIsLoading(true);
      getFileList();
    }
  }, [pageCount]);

  useEffect(() => {
    if (isFilter) {
      handleAPICall();
      setFilterStatus(false);
    }
  }, [isFilter]);
  
  const getPaymentPurpose = async () => {
    const data = { merc_id: userService.userData.mercid, Templatetype: "" };
    const response = await apiService.fetchData(data, "getallpurpose");
    setPaymentPurpose(response?.data || []);
  };

  const setNotificationDetail=(popIndex=null)=>{
    setTemplateDetails({
      ...templateState,
      pop_id:paymentPurpose?.[popIndex]?.purpose_id||"",
      pop_desc: paymentPurpose?.[popIndex]?.purpose_desc || "",
      sms_templateid: paymentPurpose?.[popIndex]?.sms_template_id || "",
      email_templateid: paymentPurpose?.[popIndex]?.email_template_id || "",
      whatsapp_templateid:
        paymentPurpose?.[popIndex]?.whatsapp_template_id || "",
    });
  }

  const handleTemplateDetail=(commType)=>{
    setTemplateDetails({
      ...templateDetails,
      [commType.target.id]:commType.target.checked
    })
  }

  useEffect(() => {
    getFileList();
    // getPaymentPurpose()
  }, []);

  // useEffect(() => {
  //   setNotificationDetail(paymentPurpose?.length > 0 ? 0 : null);
  // }, [paymentPurpose]);

  // useEffect(()=>{
  //   console.log(templateDetails);
  // },[templateDetails])


  const bachBottomListner = useBottomScrollListener(incrementPageCount, {
    offset: 30,
  });

  const outletContext = useOutletContext();

  outletContext.setBottomListnerValue(bachBottomListner);

  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <h5>Batch Upload {totalCount > 0 && `(${totalCount})`} </h5>
        <button className="btn--sm btn-primary" onClick={uploadModal.showModal}>
          <span class="material-symbols-rounded">add</span>Upload New File
        </button>
      </div>
      <div className="mt-2">
        <div className="fc-nowrap flex-center justify-content-between mt-4">
          <label className="input input--sm fc-4">
            <input
              type="text"
              placeholder="Search by File name"
              value={filterValue?.searchvalue || ""}
              onChange={(e) =>
                regexService?.isAlphaNum(e.target.value) &&
                setFilterValue({
                  ...filterValue,
                  searchvalue: e.target.value,
                })
              }
            />
            <button
              className="btn--xs btn-primary"
              onClick={() => {
                handleSearch();
              }}
            >
              <span class="material-symbols-rounded">search</span>
            </button>
          </label>
          <div
            className="flex-center gap-sm cursor-pointer"
            onClick={filterModal.showModal}
          >
            <span>Filter</span>
            <div className="icon">
              <span class="material-symbols-rounded">filter_list</span>
            </div>
          </div>
        </div>
        <div className="cover border rounded-border-sm mt-3">
          <table>
            <thead>
              <tr>
                <th>File Name</th>
                <th>Campaign ID</th>
                <th>Record Count</th>
                <th>Created by</th>
                <th>Created on</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            {!isLoading && fileList?.length > 0 && (
              <tbody className="table-body">
                {fileList.map((data) => (
                  <tr id={data.pk_id}>
                    <td
                      className="f-600 cursor-pointer"
                      onClick={() => hadleRowSelect(data)}
                    >
                      {data.filename}
                    </td>
                    <td>{data.pk_id}</td>
                    <td>{numberFormat(data.recordcount)}</td>
                    <td>{data.createdby}</td>
                    <td>{dateFormat(data.createddt)}</td>
                    <td>
                      <StatusChip status={data?.filestatus} />
                    </td>
                    {data?.filestatus?.toUpperCase() === "EXECUTED" && (
                      <td className="flex-center justify-content-center">
                        <div
                          className="list-icon"
                          onClick={() => handleFileDownload(data)}
                        >
                          <span class="material-symbols-rounded">download</span>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {((isPagination || isLoading) && (
            <div className="no-records">Loading...</div>
          )) ||
            (fileList?.length === 0 && (
              <div className="no-records">No Records to display</div>
            ))}
        </div>
      </div>
      {uploadModal.isModal && (
        <Modal>
          <div className="modal-wrapper">
            <div className="modal rounded-border-sm">
              <div className="modal-head">
                <h5>Upload New File</h5>
                <div className="list-icon" onClick={uploadModal.hideModal}>
                  <span class="material-symbols-rounded">close</span>
                </div>
              </div>
              <div className="modal-body overflow-y-auto">
                <div className="input-wrapper">
                  <p className="input-title">File Name</p>
                  <label className="input">
                    <input
                      type="text"
                      placeholder="Enter File Name"
                      value={fileName || ""}
                      onChange={(e) =>
                        regexService.isAlphaNum(e.target.value) &&
                        setFileName(e.target.value)
                      }
                    />
                  </label>
                </div>
                {/* <div className="input-wrapper">
                <p className="input-title">Purpose of Payment</p>
                {(paymentPurpose?.length > 0 && (
                        <>
                          <label className="select input-wrapper">
                            <select
                              onChange={(e) =>
                                setNotificationDetail(e.target.value)
                              }
                            >
                              {paymentPurpose?.map((e, index) => (
                                <option value={index}>{e.purpose_desc}</option>
                              ))}
                            </select>
                          </label>
                          <div className="flex gap-lg">
                            {templateDetails?.sms_templateid && (
                              <label className="input-radio-grp">
                                <input
                                  type="checkbox"
                                  id="sms_checked"
                                  defaultChecked={false}
                                  checked={templateDetails?.sms_comm}
                                  value={templateDetails?.sms_templateid}
                                  onChange={(e) => {
                                    handleTemplateDetail(e)
                                    // setInputValue(e);
                                    // handleMessageContent(
                                    //   "SMS",
                                    //   e?.target?.value
                                    // );
                                  }}
                                />
                                SMS
                              </label>
                            )}
                            {templateDetails?.email_templateid && (
                              <label className="input-radio-grp">
                                <input
                                  type="checkbox"
                                  defaultChecked={false}
                                  checked={templateDetails?.email_comm}
                                  id="email_checked"
                                  value={templateDetails?.email_templateid}
                                  onChange={(e) => {
                                    handleTemplateDetail(e)
                                    // setInputValue(e);
                                    // handleMessageContent(
                                    //   "EMAIL",
                                    //   e?.target?.value
                                    // );
                                  }}
                                />
                                Email
                              </label>
                            )}
                            {templateDetails?.whatsapp_templateid && (
                              <label className="input-radio-grp">
                                <input
                                  type="checkbox"
                                  id="ws_checked"
                                  checked={templateDetails?.whatsapp_comm}
                                  defaultChecked={false}
                                  value={templateDetails?.whatsapp_templateid}
                                  onChange={(e) => {
                                    handleTemplateDetail(e)
                                    // setInputValue(e);
                                    // handleMessageContent(
                                    //   "WHATSAPP",
                                    //   e?.target?.value
                                    // );
                                  }}
                                />
                                Whatsapp
                              </label>
                            )}
                          </div>
                        </>
                      )) || (
                        <div>
                          <p className="help-text text-danger mt-1">
                            No Template Found*
                          </p>
                        </div>
                      )}
                </div> */}
                <div className="input-wrapper">
                  <div className="flex justify-content-between">
                    <p className="input-title">Choose your file</p>
                    <p
                      className="flex-center gap-sm mini-text text-primary cursor-pointer"
                      onClick={() => downloadSampleFormat()}
                    >
                      Sample format
                      <span class="material-symbols-rounded">download</span>
                    </p>
                  </div>
                  <div className="file-upload">
                    <label htmlFor="file" id="file-name">
                      Select or Drag and Drop your file to Upload
                    </label>
                    <div class="zone">
                      <div class="selectFile">
                        <input
                          type="file"
                          name="files"
                          title=""
                          id="file"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          onChange={() => handleFileValidation()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-foot justify-content-end">
                {(fileName?.length >= 3 && isFile && (
                  <button className="btn-primary" onClick={submitFile}>
                    Submit
                  </button>
                )) || <button className="btn-disabled">Submit</button>}
              </div>
            </div>
          </div>
        </Modal>
      )}
      {dataModal.isModal && (
        <Modal>
          <div className="side-modal modal--sm">
            <div className="modal-head border-bottom">
              <div>
                <h6>File Details</h6>
              </div>
              <div className="icon" onClick={dataModal.hideModal}>
                <span class="material-symbols-rounded">close</span>
              </div>
            </div>
            <div className="modal-body overflow-y-auto pb-4">
              <div className="flex-center justify-content-between">
                <div className="my-2">
                  <p className="f-500 title">File Name</p>
                  <h6>{rowData?.filename}</h6>
                </div>
                <div className="fc-auto">
                  <StatusChip status={rowData?.filestaus} />
                </div>
              </div>
              <div className="fc flex-nowrap justify-content-between">
                <div className="input-wrapper mt-2 fc-5">
                  <p className="title">File ID</p>
                  <p>{rowData?.pk_id}</p>
                </div>
                <div className="input-wrapper mt-2 fc-5">
                  <p className="title">Total Records</p>
                  <p>{rowData?.recordcount}</p>
                </div>
              </div>
              <div className="fc flex-nowrap justify-content-between">
                <div className="input-wrapper fc-5">
                  <p className="title">Created on</p>
                  <p>{dateFormat(rowData?.createddt)}</p>
                </div>
                <div className="input-wrapper fc-5">
                  <p className="title">Created By</p>
                  <p>{rowData?.createdby}</p>
                </div>
              </div>
              <hr />
              <div className="flex fc-12 justify-content-between">
                <p>File Report</p>
                {rowData?.filestatus?.toUpperCase() === "EXECUTED" && (
                  <div
                    className="list-icon"
                    onClick={() => handleFileDownload(rowData)}
                  >
                    <span class="material-symbols-rounded">download</span>
                  </div>
                )}
              </div>
              <div className="flex-nowrap mt-2">
                <div className="fc flex-nowrap justify-content-between input-wrapper">
                  <div className="fc-5">
                    <p className="title">Success Count</p>
                    <p>{rowData?.invoicecount || 0}</p>
                  </div>
                  <div className="fc-5">
                    <p className="title">Failed Count</p>
                    <p>{rowData?.recordcount - rowData?.invoicecount || 0}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {filterModal?.isModal && (
        <Modal>
          <div className="modal modal--sm rounded-border-sm">
            <div className="modal-head">
              <h6 className="f-500">Filter</h6>
              <div className="list-icon" onClick={() => handleFilter("CLOSE")}>
                <span class="material-symbols-rounded">close</span>
              </div>
            </div>
            <div className="modal-body h-30 py-2">
              <p className="title ">Created Date</p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  className="date-picker mr-2  mt-2"
                  label="From Date"
                  format="DD-MM-YYYY"
                  value={dayjs(filterValue?.fromdate)}
                  minDate={dayjs().subtract(6, "months")}
                  maxDate={dayjs()}
                  closeOnSelect
                  onChange={(value) => {
                    handleDateChange(value, "fromdate");
                  }}
                />
                <MobileDatePicker
                  className="date-picker mt-2 cursor-pointer"
                  label="To Date"
                  format="DD-MM-YYYY"
                  value={dayjs(filterValue?.todate)}
                  minDate={dayjs(filterValue?.fromdate)}
                  maxDate={dayjs()}
                  closeOnSelect
                  onChange={(value) => handleDateChange(value, "todate")}
                />
              </LocalizationProvider>
            </div>
            <div className="modal-foot">
              <div className="flex-center justify-content-end gap-md w-100">
                <button
                  className="btn-outline btn--sm"
                  onClick={() => handleFilter("RESET")}
                >
                  Reset
                </button>
                <button
                  className="btn-primary btn--sm"
                  onClick={() => handleFilter("APPLY")}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default BulkUpload;
